<template>
  <div class="base-timer">
    <span class="base-timer__label" :class="{ 'base-timer__run': run }">
      {{ timeLeft | asMmSs }}
    </span>
  </div>
</template>

<script>
export default {
  name: "timerDisplay",

  props: ["duration", "run"],

  data() {
    return { timeLeft: 0 };
  },

  watch: {
    duration: {
      immediate: true, // call it upon creation too
      handler(duration) {
        if (duration <= 0) this.timeLeft = 0;
        else if (!this.timeLeft || this.timeLeft < 0) this.timeLeft = duration;
        else this.timeLeft = duration;
      },
    },
  },
};
</script>

<style scoped>
.base-timer__run {
  color: red;
}
</style>
